import styled from 'styled-components';
import { UserOutlined } from '@ant-design/icons';

export const StyledIcon = styled(UserOutlined)`
  display: flex;
  align-items: center;
  justify-content: center;
    margin-right: var(--spacing-small);
  height: 100%;
    color: var(--color-highlight);
`;
